import { useTheme } from "@emotion/react";
import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Fields from "../Fields";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import { PaymentType, PaymentTypeNew } from "../../../../utilities/Enum";
import { useEmployees } from "../../../employee/Provider";
import { useReports } from "../../Provider";
import { TransformFromPercent } from "../../../../utilities/functions";
import ErrorsList from "../../../../ui/ErrorsList";

const yupSchema = Fields.reduce(createYupSchema, {
  paidStatus: Yup.number(),
  discount: Yup.number()
    .min(1, "discount must be greater than zero")
    .max(100, "discount must be later than 100"),
});
const schema = Yup.object().shape(yupSchema);

const ChangePaidStatusForm = ({ row, handleClose }) => {
  const theme = useTheme();

  const [paymentTypeId, setPaymentTypeId] = useState(0);
  const [error, setError] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const {
    state: { companyIdAtt, VoidReasonsList, siteIdAtt, compAccountList },
    fetchVoidReasonsList,
    fetchCompAccountList,
    RepayTransaction,
  } = useReports();

  const {
    state: { list: employees },
    fetchList: fetchEmployees,
  } = useEmployees();

  const getData = (name) => {
    const dataMap = {
      newPaymentTypeId: [
        ...(PaymentTypeNew?.map(({ id, name }) => ({
          id: id,
          name: name,
        })) || []),
      ],
      // employeeId: [
      //   ...(employees?.map(({ id, fullName }) => ({
      //     id: id,
      //     name: fullName,
      //   })) || []),
      // ],
      // notes: [
      //   ...(VoidReasonsList?.map(({ reason }) => ({
      //     id: reason,
      //     name: reason,
      //   })) || []),
      // ],
      // compAccountId: [
      //   ...(compAccountList?.map(({ accountName }) => ({
      //     id: accountName,
      //     name: accountName,
      //   })) || []),
      // ],
    };

    return dataMap[name] || [];
  };

  // useEffect(() => {
  //   fetchEmployees(companyIdAtt, 0, 1, 100);
  // }, [fetchEmployees, companyIdAtt]);

  // useEffect(() => {
  //   fetchVoidReasonsList(siteIdAtt);
  // }, [fetchVoidReasonsList, siteIdAtt]);

  // useEffect(() => {
  //   fetchCompAccountList(siteIdAtt);
  // }, [fetchCompAccountList, siteIdAtt]);

  const onSubmit = async (values) => {
    // values.discount = TransformFromPercent(values?.discount);
    try {
      await RepayTransaction(row?.id, values);
      handleClose();
    } catch (error) {
      window.scroll(0, 0);
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Typography
        sx={{ textAlign: "center", marginRight: "10px" }}
        variant="Poster"
        component="h4"
        gutterBottom
      >
        Select new payment type
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Box>
        {Fields.map((f, index) => (
          <Box key={index}>
            {f.select ? (
              <FormControl
                sx={{
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                  width: theme.dimensions.width,
                  // display:
                  //   f.name === "notes" && paymentTypeId !== 1
                  //     ? "none"
                  //     : f.name === "compAccountId" && paymentTypeId !== 2
                  //     ? "none"
                  //     : null,
                }}
              >
                <span style={{ fontSize: "12px" }}>{f.label}</span>
                <Select
                  sx={{
                    mt: theme.dimensions.mt,
                  }}
                  error={!!errors[f.name]}
                  onChange={(e) => {
                    if (f.name === "PaymentTypeId") {
                      setPaymentTypeId(e.target.value);
                    }
                  }}
                  defaultValue={f.name === "PaPaymentTypeId" && paymentTypeId}
                  inputProps={{
                    ...register(f.name),
                  }}
                  size="small"
                >
                  {getData(f.name)?.map((s, index) => (
                    <MenuItem key={index} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <FormControl
                sx={{
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                }}
              >
                <span style={{ fontSize: "12px" }}>{f.label}</span>
                <TextField
                  name={f.name}
                  error={!!errors[f.name]}
                  helperText={errors[f.name]?.message}
                  fullWidth
                  size="small"
                  type="number"
                  defaultValue={row?.price}
                  sx={{
                    width: theme.dimensions.width,
                    mt: theme.dimensions.mt,
                    mb: theme.dimensions.mb,
                  }}
                  inputProps={{
                    ...register(f.name),
                  }}
                ></TextField>
              </FormControl>
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ width: theme.dimensions.width }}>
        <Button
          type="submit"
          sx={{
            background: theme.color.blackBackground,
            color: "white",
            width: "100%",
            mb: 1.3,
            "&:hover": {
              background: `${theme.color.black}`,
            },
          }}
        >
          Save
        </Button>
        <Button
          onClick={handleClose}
          sx={{
            background: theme.color.gray200,
            color: "black",
            width: "100%",
            "&:hover": {
              background: `${theme.color.gray300}`,
            },
          }}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default ChangePaidStatusForm;
